import dynamic from "next/dynamic";
import { memo } from "react";
const Floor = dynamic(() => import("./Floor"));

const FloorMemo = () => {
  return <Floor />;
};

const FloorWrapper = memo(FloorMemo);

export default FloorWrapper;
